import { createSlice } from "@reduxjs/toolkit";

const STORAGE_KEY = "showEsgAdminFeatures";

/**
 * Defaults to true (admin features visible) so an ESG Admin's view doesn't change
 * until they explicitly toggle it off via the header icon.
 */
const loadShowAdminFeatures = () => {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    return stored === null ? true : stored === "true";
  } catch (error) {
    console.error("Error loading showEsgAdminFeatures from localStorage:", error);
    return true;
  }
};

export const adminViewSlice = createSlice({
  name: "adminView",
  initialState: {
    showAdminFeatures: loadShowAdminFeatures(),
  },
  reducers: {
    toggleAdminFeatures: (state) => {
      state.showAdminFeatures = !state.showAdminFeatures;
      localStorage.setItem(STORAGE_KEY, String(state.showAdminFeatures));
    },
  },
});

export const { toggleAdminFeatures } = adminViewSlice.actions;

export default adminViewSlice.reducer;
